import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, useLocation, useParams } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState, AppThunkAction } from '../../store';
import { SessionModel } from '../../models/SessionModel';
import * as AddUsrModels from '../../models/AdditionalUser';
import * as AddUsrStore from '../../store/AdditionalUserList';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel, SaPhone } from '../Misc/SawinComponents';
import { useEffect } from 'react';

type MyProps =
    { AdditionalUsers: AddUsrModels.AdditionalUserList, SessionState: SessionModel } & typeof AddUsrStore.actionCreators;


const AdditionalUserList: React.FunctionComponent<MyProps> = (props: MyProps) => {

    useEffect(() => {
        props.retrieve();
    }, []);


    const AdditionalUserListCard: React.FunctionComponent<{ item: AddUsrModels.AdditionalUser, parentProps: MyProps }> = (props: { item: AddUsrModels.AdditionalUser, parentProps: MyProps }) => {        

        const clickHandler = (e: React.MouseEvent) => {            
            props.parentProps.delete(props.item.phoneNumber);
        }

        return (<Card className='additionalUserList-card'>
            <CardBody>
                <Row>
                    <Col xs="12" sm="5">
                        {props.item.phoneLabel}
                    </Col>
                    <Col xs="12" sm="5">
                        <SaPhone UnformattedPhone={props.item.phoneNumber} />
                    </Col>
                    <Col xs="12" sm="2">
                        <Button onClick={clickHandler}>Delete</Button>
                    </Col>
                </Row>
            </CardBody>
        </Card>);
    }


    return (
        <Container fluid={true}>
            <LoadingIcon loading={props.AdditionalUsers.loading} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
            <Row>
                <Col className='center-align' xs={12}>
                    <Link to={{ pathname: "/AdditionalUserEntry" }}><Button className='additionalUserList-newBtn'>New Additional User</Button></Link>
                </Col>
            </Row>
            {props.AdditionalUsers.items.map((item, index) =>
                <Row key={index} >
                    <Col xs={12}>
                        <AdditionalUserListCard item={item} parentProps={props}> </AdditionalUserListCard>
                    </Col>
                </Row>
            )}
        </Container>
    );
   
}
export default connect(
    (state: ApplicationState) => ({ AdditionalUsers: state.additionalUserListState, SessionState: state.sessionState }),
    AddUsrStore.actionCreators)(AdditionalUserList as any);
